import React from 'react'
import {parseHostname} from '@ta-interaktiv/parse-hostname'
import Masthead from '@ta-interaktiv/react-polymorphic-masthead'
import Profile from '../../components/profile'
import Answer from '../../components/answer'
import Question from '../../components/question'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import Tracking from '@ta-interaktiv/react-polymorphic-tracking'
import StandaloneShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons'
import CopyrightNotice from 'ta-react-polymorphic-copyright-notice'
import Waypoint from 'react-waypoint'
import 'ta-semantic-ui/semantic/dist/components/reset.css'
import 'ta-semantic-ui/semantic/dist/components/site.css'
import 'ta-semantic-ui/semantic/dist/components/segment.css'
import 'ta-semantic-ui/semantic/dist/components/header.css'
import 'ta-semantic-ui/semantic/dist/components/container.css'
import 'ta-semantic-ui/semantic/dist/components/divider.css'
import 'ta-semantic-ui/semantic/dist/components/image.css'
import 'ta-semantic-ui/semantic/dist/components/button.css'
import 'ta-semantic-ui/semantic/dist/components/table.css'
import 'ta-semantic-ui/semantic/dist/components/item.css'
import 'ta-semantic-ui/semantic/dist/components/card.css'
import 'ta-semantic-ui/semantic/dist/components/icon.css'
import 'ta-semantic-ui/semantic/dist/components/list.css'
import 'ta-semantic-ui/semantic/dist/components/rail.css'
import 'styles/App.css'

export default class AppComponent extends React.Component {
  constructor (props) {
    super(props)

    this.domain = parseHostname().publicationDomain
  }

  render () {
    return (
      <div className='index'>

        <Masthead inverted articleID='29445026' additionalFacebookShares={689} />

        <header className='ui inverted block vertical segment desktop-only' style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.5)), url(${require(
            './header.jpg')})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: '100vh'
        }}>

          <div className='ui container'>
            <div className='header block'>
              <div className='ui container'>
                <h1 className='ui huge white header'>
                Sie zeigen es uns
                </h1>
                <p className='ta lead'>Sexismus und Ressentiments: Wie es ist, als Frau in der Schweiz Filme zu drehen.
                </p>
              </div>
            </div>

          </div>
        </header>

        <header className='ui inverted block vertical segment mobile-only' style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.3), rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(${require(
            './header_mobile.jpg')})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: '100vh'
        }}>

          <div className='ui container'>
            <div className='header block'>
              <div className='ui container'>
                <h1 className='ui huge white header'>
                Sie zeigen es uns
                </h1>
                <p className='ta lead'>Wie es ist, als Frau in der Schweiz Filme zu drehen.
                </p>
              </div>
            </div>

          </div>
        </header>

        <figcaption className='ui container ta caption'>
          Lisa Brühlmann, Eva Vitija, Corina Schwingruber Ilic, Anna Thommen und Lisa Blatter beim TA-Gespräch. Foto: Sophie Stieger.
        </figcaption>

        <main className=''>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <p className='ta lead'>
                <div className='ta author'>Von Pascal Blum
                </div>
              </p>
              <p className='ta lead'>
                Sie sind zwischen 30 und 45, sie haben schon Filme gemacht oder versuchen es gerade mit ihrem ersten. Fünf Schweizer Regisseurinnen treffen sich zum Gespräch über ihre Arbeit, vom Kurz- über den Dokumentar- bis zum Spielfilm. Ressentiments und Sexismus begegnen sie immer wieder: Interviewer erklären ihnen die Welt, Männer hören nicht auf ihre Anweisungen, von Auftraggebern werden sie unterschätzt. Die Stoffe, die sie für ihre Filme entwickeln, haben damit zu tun: Wie sie mit ihrem eigenen Blick auf die Welt schauen – und wie sie als Regisseurinnen von aussen wahrgenommen werden.
              </p>

              <Waypoint scrollableAncestor={window} onEnter={(event) => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    'event': 'startReading'
                  }
                  )
                }
              }} />

            </div>
          </section>

          <aside className='ui vertical  segment' style={{
            background: '#feebd5',
            color: '#333'
          }}>
            <div className='ui container'>
              <div className='ui relaxed two column stackable grid'>

                <div className='column'>
                  <Profile avatarSrc={require('./lisa_blatter.jpg')}
                    name='Lisa Blatter'>1979 in Heide, Deutschland geboren. Filmausbildung an der Zürcher Hochschule der Künste. Zum Kollektivfilm «Heimatland» über eine Wolke, die die Schweiz bedroht, steuerte sie eine Episode bei. Ihr Debütfilm «Skizzen von Lou» hatte Premiere am letzten Zurich Film Festival und kam kürzlich ins Kino. Produzentin bei der Firma 2:1 Film. </Profile>
                </div>

                <div className='column'>
                  <Profile avatarSrc={require('./lisa_bruehlmann.jpg')}
                    name='Lisa Brühlmann'>1981 in Zürich geboren, Regisseurin und Schauspielerin, u.a. im «Tatort». Filmstudium an der Zürcher Hochschule der Künste. Dieses Jahr startet ihr Kinodebüt «Blue My Mind», worin sich ein Mädchen auf die Suche nach seiner Herkunft macht.  </Profile>
                </div>

                <div className='column'>
                  <Profile name='Eva Vitija' avatarSrc={require(
                    './eva_vitija.jpg')}>Die Regisseurin und Drehbuchautorin wurde 1973 in Basel geboren. Ausbildung an der Deutschen Film- und Fernsehakademie in Berlin zur Drehbuchautorin. Mit ihrem Dokumentarfilm «Das Leben drehen» über ihren dauerfilmenden Vater gewann sie 2016 den Zürcher und den Basler Filmpreis und den Prix de Soleure der Solothurner Filmtage.</Profile>
                </div>

                <div className='column'>
                  <Profile name='Corina Schwingruber Ilić' avatarSrc={require(
                    './corina_schwingruber_ilic.jpg')}>Geboren 1981 in Werthenstein. Kunststudium in Basel und Belgrad, Abgängerin der Hochschule Luzern Design & Kunst, Abteilung Video. Regisseurin von preisgekrönten Kurzdokumentarfilmen und Cutterin. </Profile>
                </div>

                <div className='column'>
                  <Profile name='Anna Thommen'
                    avatarSrc={require('./anna_thommen.jpg')}>Geboren 1980 in Arlesheim im Baselbiet, arbeitete als Primarlehrerin, bevor sie in Luzern und Zürich die Filmschule absolvierte. «Neuland», ihr Porträt einer Basler Integrationsklasse, gewann etliche Festivalpreise. Derzeit arbeitet sie am Dokumentarfilm «Zurück aus Idomeni» über freiwillige Helfer sowie am Spielfilm «Im Schopf», der über drei Generationen im gleichen Haus spielt. </Profile>
                </div>

              </div>
            </div>
          </aside>

          <Waypoint scrollableAncestor={window} onEnter={(event) => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                'event': 'startInterview'
              }
              )
            }
          }} />

          <section className='ui vertical segment'>

            <div className='ui text container'>

              <Question q='Kriegt man als Regisseurin Ressentiments zu spüren, einfach deshalb, weil man eine Frau ist?' classes='ui small black header'>
                <Answer who='Anna Thommen'>
                  <p>
                    Eigentlich überhaupt nicht. Ich habe gerade wieder mit einem männlichen Team gedreht, das kein Problem damit gehabt hat, dass ich die Chefin bin. Aber dann merkt man: Auch wenn in der eigenen Welt alles in Ordnung sein mag, selbst was die Aufteilung der Kinderbetreuung angeht, herrscht nach der Wahl von Trump eine völlig andere Realität, die man kaum mit der eigenen in Übereinstimmung bringt. Wie eine Fiktion, die sich als Wirklichkeit ausgibt.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Du hast ja aber vielleicht auch Glück, weil dein Mann sich zu Hause so einbringt. Bei vielen Frauen ist es nicht unbedingt ganz so einfach, sobald sie Kinder bekommen. Ich kenne einige Filmemacherinnen, die ausgestiegen sind, weil sie mehr Geld verdienen und Kinder betreuen mussten.
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Ich bin in einem engagierten Haushalt aufgewachsen und weiss noch, dass die Dozentinnen in der Filmschule mir gesagt haben: «Lisa, du musst Frauenfilme machen. Frauen sind dazu da, der Welt starke Frauenfiguren zu zeigen.» Ich dachte damals: Ich bin doch viel zu emanzipiert aufgewachsen, um mir über Emanzipation Gedanken zu machen. Aber jetzt merke ich, dass das überhaupt nicht stimmt. Dass wir noch immer nicht sehr weit sind, spürt man an jeder Ecke.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Woran merkst du es?
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    An mir selber. Ich rege mich über mich selbst auf, weil ich einem Mann den Vorrang lasse oder ihn lauter reden lasse. Danach bin ich wütend, weil ich mich nicht durchgesetzt habe.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Ich weiss von vielen Frauen, dass sie sich nicht getrauen, beim Lohn hart zu verhandeln, während das für die meisten Männer selbstverständlich ist.
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Ich war einige Mal als Regieassistentin auf Sets. Ruft man zum Beispiel «Ruhe», tun die Frauen, was man sagt. Aber die Männer nicht immer. Führt man selber Regie, kann es vorkommen, dass die Techniker missmutig werden, wenn etwas nicht nach Plan gedreht wird. Ich glaube, Männer kriegen solche Situationen viel besser in den Griff. Ich muss mich nur schon anstrengen, um es so hinzukriegen, wie ich es hinkriegen will.
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Für mein Spielfilmdebüt «Blue My Mind» war es mir wichtig, eine überproportional hohe Frauenquote am Set zu haben. Trotzdem hatte ich den Eindruck, dass meine Autorität ausgerechnet von einzelnen weiblichen Teammitgliedern nicht immer respektiert wurde.
                  </p>
                </Answer>
              </Question>

              <Question q='Erleben Sie in Ihrer Arbeit häufig Sexismus?' classes='ui small black header'>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Ich merke ihn sehr stark im Alltag.
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Ich habe einmal auf einer Baustelle gedreht. Die Arbeiter waren erst skeptisch, als sie eine Frau mit einer Kamera sahen. Aber irgendwann haben sie gemerkt, dass wir jeden Tag, bei jedem Wetter dort sind. Daraus entstand Respekt. Ich gebe mich in solchen Fällen manchmal extra kräftiger, als ich bin. Weil ich denke: «Denen zeig ichs.»
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Ich finde es problematisch, wenn man als Frau beginnt, männliche Attribute herauszustellen, um besser akzeptiert zu werden. Ich weiss ja auch als Frau mit eher feineren Zügen, was gut ist für meinen Film. Es braucht überhaupt ein Umdenken in der Gesellschaft, dass weibliche Führung nicht dasselbe sein muss wie männliche.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Dazu fällt mir gerade was ein. Ich sass einmal in einer Jury, die Förderbeiträge vergab. Bei einem Dossier, das von einer Frau geschrieben war, gab es einen deutlichen Unterschied nach Geschlecht. Alle Frauen wollten das Filmprojekt unterstützen, während alle Männer dagegen waren, weil sie es nicht verstanden. Wir Frauen mussten dann den Männern im Gremium den Film erklären.
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Was war anders an diesem Dossier?
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Es war sehr intuitiv geschrieben, es ging um Atmosphären, um Dinge zwischen den Zeilen, es war nicht sehr strukturiert. Trotzdem fand ich, dass die Regisseurin genau wusste, was sie will.
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Das sind aber auch wichtige Aspekte für einen Film: Intuition, Stimmung.
                  </p>
                </Answer>
              </Question>

              <Question q='Zementiert man so nicht das Klischee über angeblich typisch weibliche Eigenschaften wie Intuition?' classes='ui small black header'>

                <Answer who='Anna Thommen'>
                  <p>
                    Das war ja nicht bei allen Dossiers so. Es unterstreicht aber auch, dass man sich nicht «männlich» geben muss, um sich als Regisseurin durchzusetzen. Der Protagonist meines Kurzdokumentarfilms «Second Me» sagte mir: «Du kannst mich filmen, aber mir kommt kein Mann ins Haus.»
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Warum nicht?
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Er fand, dass Männer sehr schnell kompetitiv agieren oder anfangen, den Platzhirsch zu spielen. Er habe lieber Frauen, weil die auf ihn eingehen würden.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Man wird als Frau ja auch gerne ein wenig unterschätzt. Das kann aber auch ein Vorteil sein. Leute, die man für einen Dokumentarfilm interviewt, getrauen sich zum Beispiel eher, sich zu öffnen, währenddem sie einem Mann gegenüber vielleicht eher die Fassung wahren würden.
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Es kann auch passieren, dass Interviewte damit beginnen, einer Regisseurin die Welt zu erklären.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Mansplaining!
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Es ist eigentlich furchtbar, wenn Leute denken, einer Frau müsse man gewisse Dinge erklären. Für einen Dokumentarfilm ist das aber gut!
                  </p>
                </Answer>
              </Question>

            </div>
          </section>

          <div className='black-bg'>
            <div className='ui container'>
              <div className='videoWrapper'>
                <iframe className='externalNNIFrame' src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@287020|showLogo@0|autoStart@0|mute@0|showAds@true|previewPath@https://server025.newsnetz.tv/287020/frame-1-287020.jpg|platform@desktop' allowFullScreen='true' scrolling='no' frameBorder='no' />
              </div>
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                «Intimität zu thematisieren heisst auch, das Private politisch zu machen», sagt Eva Vitija.
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Waypoint scrollableAncestor={window} onEnter={(event) => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    'event': '50ContentRead'
                  }
                  )
                }
              }} />

              <Question q='Wie übersetzt man einen engagierten Blick auf die Leinwand? All Ihre Filme haben mehr oder weniger deutliche politische Ebenen, seien es die Spiel- oder die Dokumentarfilme, seien es Themen wie Migration, Strukturwandel, sexuelle Belästigung oder Wohlstandslangeweile.' classes='ui small black header'>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Ich habe noch nie probiert, einen Film explizit über ein Thema zu drehen, sei das der Sexismus oder etwas anderes. Ich arbeite intuitiv und merke erst im Nachhinein, welche Themen es waren, die mich beschäftigten. Das kann Monate dauern, bis man merkt: Eigentlich geht es mir um eine weibliche Befreiungsgeschichte.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                     Ich denke, die Übersetzung passiert automatisch, weil wir Frauen sind. Gerade schreibe ich an einem Drehbuch für einen Spielfilm, in dem es ums Aufwachsen in einem kleinen Dorf geht, wo der Sexismus alltäglich ist. Das führt mich zurück in die eigene Kindheit, und mir wird erst jetzt richtig bewusst, was man da als Mädchen alles erleben musste.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Wenn ich Drehbuchautoren betreue, fällt mir auf, dass Männer oft katastrophale Frauenfiguren entwerfen. Meine Arbeit besteht dann darin, Rollenklischees wegzuschaffen. Ausserdem versuche ich, Frauen untereinander zu vernetzen. Viele Frauen unserer Generation sind sich gar nicht bewusst, dass sehr viele Probleme weiterbestehen. Man merkt es erst, wenn man älter wird und sich austauscht. Und sieht: Alle haben ähnliche Probleme.
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Nach dem Filmstudium habe ich gemerkt, dass das, was es gibt, auf der Vorarbeit unserer Vorgänger beruht. Und dass es jetzt an uns ist, das weiterzuentwickeln. Denn gut ist es noch nicht. Und wenn man nicht aufpasst, wird es wieder schlechter.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Ich war im Vorstand des Basler Filmfördervereins Balimage, fünf Männer und ich. Dort fand ich es nicht immer einfach, mich durchzusetzen. Die politische Lobbyarbeit war etwas Neues für mich. Die anderen Vorstandsmitglieder haben das einfach gemacht, die haben Politiker angerufen, um sie zu einem Kaffee zu treffen. Aber wie hätte das gewirkt, wenn ich sie angerufen hätte?
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Ich habe mich das bis vor einigen Jahren auch nicht getraut. Aber je mehr Frauen irgendwo dazustossen, umso einfacher kann man sich zusammenschliessen. Ich habe mich nun zum ersten Mal mit einem Kantonsrat alleine getroffen und über Filmpolitik gesprochen. Aber das musste ich zuerst einmal lernen.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Ich bin keine Rampensau, muss mich überwinden, an Podiumsdiskussionen aufzutreten. Es ist auch gar nicht einfach, Teilnehmerinnen für Podien zu gewinnen. Frauen überlegen sich viel genauer: Bin ich wirklich kompetent genug? Fragen die von der SRF-«Arena» einen Mann, ob er in die Sendung kommen will, sagt er: «Ja! Worum gehts?» Fragen sie eine Frau, sagt sie: «Worum gehts? Wäre da nicht jemand anders geeigneter?»
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Vielleicht lernen Männer auch früher, dass es an ihnen ist, Stellung zu beziehen. In unserer Produktionsfirma arbeitet ein einziger Mann, den wir manchmal vorschicken, damit er die unangenehmen Dinge erledigt. Schon als Kind war es so: Die Mädchen hatten die dummen Ideen – und trugen es den Buben auf, sie zu verwirklichen.
                  </p>
                </Answer>
              </Question>

            </div>
          </section>

          <div className='black-bg'>
            <div className='ui container'>
              <div className='videoWrapper'>
                <iframe className='externalNNIFrame' src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@287022|showLogo@0|autoStart@0|mute@0|showAds@true|previewPath@https://server025.newsnetz.tv/287022/frame-1-287022.jpg|platform@desktop' allowFullScreen='true' scrolling='no' frameBorder='no' />
              </div>
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Mag es, wenn es in ihren Dokumentarfilmen menschelt: die Regisseurin Corina Schwingruber Ilic.
          </figcaption>

          <div className='ui text container' style={{position: 'relative'}}>
            <aside className='ui right rail computer or lower hidden'>
              <FeedbackMessage additionalClasses={[]} />
            </aside>
          </div>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Question q='Ist es albern zu sagen, dass Frauen anders Filme drehen?' classes='ui small black header'>

                <Answer who='Lisa Blatter'>
                  <p>
                    Natürlich gibt es Unterschiede, aber man muss die Spaltung vermeiden. Wir wollen nicht beim Frauenfilm enden. Ich höre manchmal: «Das ist so ein Frauenfilm, das verstehen wir sowieso nicht.» Aber der Frauenfilm im Arthouse-Bereich, das ist ja wie die Nische der Nische.
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    «Frauenfilm», das klingt schon so verstaubt. Logisch traue ich mir auch zu, grosse Spielfilmbudgets oder Blockbusterstoffe umzusetzen. Es geht ja nicht um Geschlechterspaltung: Jeder und jede dreht einen Film anders.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Die Internet Movie Database hat inzwischen ein F-Rating eingeführt, mit dem Filme ausgezeichnet werden, die entweder eine Regisseurin, eine Autorin oder einen weiblichen Star vorweisen können. Ist das gut? Mich schreckt das eher ab.
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Mich auch. Das klingt, als würde man sagen: «Du bist eine Frau, wäre das nicht ein netter Film für dich?» Man kann etwas auch schädigen, indem man es thematisiert.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Es ist immer noch so, dass Filme von Frauen weniger Geld einspielen, dafür gewinnen sie mehr Festivalpreise. Die Frage ist schon: Warum sprechen Filme aus eher weiblicher Warte kein grosses Publikum an? Weil es Filme mit kleineren Budgets sind, sie sowieso weniger Publikum ins Kino locken? Oder weil wir uns «die weibliche Perspektive» nicht so gewohnt sind?
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Als ich für meinen Abschlussfilm «Neuland» Fördergelder beantragt habe, wurde mein Gesuch von einer Stelle mit der Begründung abgelehnt, Migration sei doch ein langweiliges Thema, darüber gebe es schon zu viele Filme. Man hat von mir erwartet, dass ich als junge Filmemacherin etwas Provokatives mache, was ausprobiere. Ich möchte aber weder als Frau noch als «junge Generation» den Erwartungen entsprechen. Sondern das machen, was mich interessiert.
                  </p>
                </Answer>

              </Question>

            </div>
          </section>

          <Waypoint scrollableAncestor={window} onEnter={(event) => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                'event': '75ContentRead'
              }
              )
            }
          }} />

          <div className='black-bg'>
            <div className='ui container'>
              <div className='videoWrapper'>
                <iframe className='externalNNIFrame' src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@287024|showLogo@0|autoStart@0|mute@0|showAds@true|previewPath@https://server025.newsnetz.tv/287024/frame-1-287024.jpg|platform@desktop' allowFullScreen='true' scrolling='no' frameBorder='no' />
              </div>
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Anna Thommen hat in «Neuland» den Alltag einer Basler Integrationsklasse dokumentiert.
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Question q='Vielfach wurde der Ausbruch aus dem Eigenen als typisch schweizerisches Motiv beschrieben. Ist das auch ein Stoff, mit dem Sie sich beschäftigen?' classes='ui small black header'>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Ich will nicht bewusst etwas aufdecken mit einem Film. Ich drehe einen Film, und der trägt ein Thema in sich.
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Bei mir ist das auch so. Es ist wie ein Knäuel aus Gefühlen, von dem man irgendwann merkt, dass er einen angeleitet hat.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Aber eine Motivation gibt es ja trotzdem. Und bei mir hat sie durchaus damit zu tun, dass man etwas sucht, womit man aus der eigenen kleinen Welt ausbrechen kann. Auch wenn man die Themen hierzulande findet.
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Manchmal denke ich, dass man eigentlich das ganze Unrecht der Welt thematisieren müsste. Da frage ich mich schon, inwiefern ich berechtigt bin, das zu tun, was ich tue, wenn es doch so viel mehr Probleme gibt. In meinem Kunststudium in Belgrad fragte mich jemand: «Du kommst ja aus der Schweiz, wieso willst du denn Kunst machen? Du hast ja nichts zu sagen.» Im ersten Moment habe ich leer geschluckt.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Ich finde das eine spezifisch männliche Diskussion: Ausbruch aus der Enge, Abgrenzung gegenüber den Älteren. Mich langweilt das furchtbar. Ich sehe im Moment eher eine Bewegung, die das Private thematisiert, überhaupt nicht nur bei Frauen.
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Und die Abgründe, die es in der Schweiz ja zuhauf gibt.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Mein nächster Dokumentarfilm handelt von Leuten, die während der Flüchtlingskrise freiwillig helfen gegangen sind. Durch ihre Erlebnisse sind sie andere Menschen geworden. Menschen, die auf die humanitäre Tradition der Schweiz stolz sind, aber sehr enttäuscht von der Art, wie sich unser Land in der Krise verhalten hat. Aus dieser Enttäuschung heraus sind sie selber politisch aktiv geworden, was ihre Sicht auf unsere Gesellschaft nachhaltig verändert hat.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Man könnte sehr viele Geschichten erzählen: über die Schalthebel der Macht, das Geld, den Rohstoffhandel. Als Drehbuchautorin habe ich lange mit dem Problem gekämpft, eine gewisse Höhe der Konflikte hinzubekommen. Ich hatte das Gefühl, Konflikte kenne ich eigentlich kaum welche. Damit tut sich der Schweizer Nachwuchs noch immer schwer: Konflikte zu erzählen. Schweizer haben auch Mühe, Bösewichter zu erschaffen.
                  </p>
                </Answer>

              </Question>

              <Question q='Dem Schweizer Film gelingen auch kaum je Kassenschlager. Muss man es sich als Regisseurin hierzulande auch ein wenig leisten können, dass man nicht so sehr aufs Publikum schielen muss?' classes='ui small black header'>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Es gibt genug Leute, die nach dem suchen, was sich gut verkauft. An Festivals und in der Branche ist es teils schockierend, da gehts manchmal nur noch darum, die eigene Karriere vorzubereiten, um die Frage, ob ein Film in Cannes läuft. Ich lasse mich gar nicht von solchen Impulsen leiten. Ich glaube, da sind wir alle ähnlich.
                  </p>
                </Answer>

                <Answer who='Anna Thommen'>
                  <p>
                    Nicht besonders erfolgsorientiert.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Das würde ich nicht sagen. Erfolgsorientiert bin ich sehr wohl, das mit dem Erfolg gelingt mir einfach nicht immer.
                  </p>
                </Answer>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Ich will vor allen Dingen gute Filme machen. Wenn der Film auch noch ein Publikumserfolg wird, freue ich mich doppelt. Aber jetzt bin ich ja immer noch an dem Punkt, an dem ich mich frage: Wie soll das alles überhaupt gehen?
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Bei meinem Erstling «Skizzen von Lou» hatte ich durchaus das Gefühl, dass ich mich damit selbst verwirklichen könne. Dass wenige Leute den Film schauen gegangen sind, ist dann aber trotzdem ein Frust. Ich weiss, dass ich den Stoff eines Films aus mir selbst schöpfen muss. Aber mit der Zeit geschieht es einem, dass man im Prozess der Übersetzung der eigenen Ideen hier und dort einen zusätzlichen Gedanken an ein mögliches Publikum verschwendet.
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    Es geht doch darum, dass die Filme wichtiger sind als der Fame.
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Sonst verliert man die Identität des Films.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    Und am Ende sind Schweizer Filme fast immer erfolglos. Sie sind oft Low-Budget, sie gehören fast immer in den Arthouse-Bereich, praktisch kein Schweizer Spielfilm ist im Kino international erfolgreich.
                  </p>
                </Answer>
              </Question>

            </div>
          </section>

          <div className='black-bg'>
            <div className='ui container'>
              <div className='videoWrapper'>
                <iframe className='externalNNIFrame' src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@287016|showLogo@0|autoStart@0|mute@0|showAds@true|previewPath@https://server025.newsnetz.tv/287016/frame-1-287016.jpg|platform@desktop' allowFullScreen='true' scrolling='no' frameBorder='no' />
              </div>
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Leben in der Bubble: Lisa Blatter über den Dreh ihres Erstlings «Skizzen von Lou».
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Question q='Müssen Sie Ihre Freunde nicht nur dazu überzeugen, sich Ihre eigenen Filme anzuschauen, sondern überhaupt dazu, einmal wieder ins Kino zu gehen?' classes='ui small black header'>

                <Answer who='Lisa Brühlmann'>
                  <p>
                    Ja. Was paradox ist: Der Serienkonsum ist extrem, und die Schweiz ist ein Paradies für Downloader. Wieso gibt es keine Plattform, auf der auch europäische Arthouse-Filme einfach zugänglich sind? Die Filmbranche muss umdenken, so wie es die Musikindustrie getan hat. Ich liebe das Kino. Aber jetzt, wo ich Kinder habe, bietet es sich halt an, auch mal einen Film zu Hause zu gucken.
                  </p>
                </Answer>

                <Answer who='Lisa Blatter'>
                  <p>
                    Man hat als Regisseurin aber schon die grosse Leinwand im Kopf. Denn im Kino sitzen, das ist Konzentration in der Bubble, deshalb fährt ein Film ein. Und ausserdem: Jeder Schweizer Film, der Aufmerksamkeit bekommt, tut der Filmbranche gut.
                  </p>
                </Answer>
              </Question>

              <Question q='Trotzdem wird er den schlechten Ruf nicht los.' classes='ui small black header'>

                <Answer who='Lisa Blatter'>
                  <p>
                    Es beginnt schon bei den Kiddies, die rümpfen bei Dialektfilmen gleich die Nase. Als ich «Skizzen von Lou» an Schulen vorgeführt habe, sagten die Teenies dann aber: «Einen Schweizer Film wollten wir uns nicht anschauen, aber deiner ist ja megacool.»
                  </p>
                </Answer>

                <Answer who='Corina Schwingruber Ilić'>
                  <p>
                    In der Schweiz ist auch die Filmbildung sehr schlecht. Wie zum Beispiel in Frankreich über Film geredet wird, das ist etwas völlig anderes! Bei uns gibt es diese Sprache gar nicht.
                  </p>
                </Answer>

                <Answer who='Eva Vitija'>
                  <p>
                    An der Zürcher Hochschule der Künste, wo ich Regie studiert habe, hatten die Leute einen sehr schlechten Eindruck vom Schweizer Film, aber gleichzeitig keine Ahnung, was es überhaupt gibt. Das fand ich schade. Der Schweizer Film ist vielfältiger und reicher, als man denkt!
                  </p>
                </Answer>
              </Question>

            </div>

            <Waypoint scrollableAncestor={window} onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  'event': 'endInterview'
                }
                )
              }
            }} />

            <aside className='ui vertical segment white-bg'>
              <div className='ui container'>
                <div className='ui image'>
                  <img src={require('./regisseurinnen.jpg')} />
                </div>
                <figcaption className='ta caption'>
                Fünf Schweizer Regisseurinnen treffen sich zum Gespräch über ihre Arbeit. Foto: Sophie Stieger.
                </figcaption>
              </div>
            </aside>

          </section>

        </main>

        <Waypoint scrollableAncestor={window}
          onEnter={(event) => {
            if (event.previousPosition ===
          'below') {
              window.dataLayer =
            window.dataLayer || []
              window.dataLayer.push({
                'event': 'contentBottom'
              }
              )
            }
          }} />

        <div className='ui vertical inverted infographic segment'>
          <div className='ui container'>
            <div className='ui stackable two column aligned grid'>
              <div className='column'>
                <table className='ui definition inverted very basic table'>
                  <tbody>
                    <tr>
                      <td>Digitales Konzept, Umsetzung:</td>
                      <td>Mathias Lutz, Interaktiv-Team</td>
                    </tr>
                    <tr>
                      <td>Video:</td>
                      <td>Mario von Ow</td>
                    </tr>
                    <tr>
                      <td>Fotos:</td>
                      <td>Sophie Stieger</td>
                    </tr>
                    <tr className='desktop-only'>
                      <td colSpan='2'><CopyrightNotice inverted /></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='column'>

                <table className='ui definition inverted very basic table'>
                  <tbody>
                    <tr>
                      <td><i className='comments icon' /></td>
                      <td>
                        <div className='content'>
                          <div className='header'> Haben Sie Anmerkungen oder
                          einen Fehler entdeckt?
                          </div>
                          <p>
                            <span>Wir freuen uns über Ihre </span>
                            <a href='mailto:interaktiv@tages-anzeiger.ch?subject=Fünf Schweizer Regisseurinnen'>Nachricht</a>
                            <span>.</span>
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan='2' className='footer-sharing'>
                        <div className='spacer'>&nbsp;</div>
                        <StandaloneShareButtons articleID='29445026' />
                        <Tracking articleId='29445026' />

                        <Waypoint scrollableAncestor={window}
                          onEnter={(event) => {
                            if (event.previousPosition ===
                                                       'below') {
                              window.dataLayer =
                                                      window.dataLayer || []
                              window.dataLayer.push({
                                'event': 'pageBottom'
                              }
                              )
                            }
                          }} />
                        <div className='spacer'>&nbsp;</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    )
  }
}

AppComponent.defaultProps = {}



// WEBPACK FOOTER //
// ./src/components/main/Main.js